var LearningSeriesData = require("learning-series-data.csv");

var LearningSeries = {

	videos: function(module, level) {
		var tutorials = _.filter(LearningSeriesData, {
			module: module, level: level, type: LearningSeries.VIDEO_TYPE
		});

		return _.sortBy(tutorials, "order");
	},
	video: function(key) {
		return _.findWhere(LearningSeriesData, {
			key: key, type: LearningSeries.VIDEO_TYPE
		});
	},

	action: function(key) {
		return _.findWhere(LearningSeriesData, {
			key: key, type: LearningSeries.ACTION_TYPE
		});
	},

	itemsInModule: function(module, type) {
		return _.filter(LearningSeriesData, {
			module: module, type: type
		});
	},
	itemsInModuleAtLevel: function(module, level, type) {
		return _.filter(LearningSeriesData, {
			module: module, level: level, type: type
		});
	},

	keysInModule: function(module, type) {
		var tutorials = _.filter(LearningSeriesData, {
			module: module, type: type
		});

		return _.map(tutorials, (tutorial) => { tutorial.key });
	},

	countComplete: function(items, completeKeys) {
		var completeItems = _.map(items, (item) => {
			return _.filter(completeKeys, (key) => { return key == item.key });
		});

		return _.flatten(completeItems).length;
	},

	firstIncompleteVideoInModule: function(module, completeKeys) {
		var videos = LearningSeries.itemsInModule(module, LearningSeries.VIDEO_TYPE);
		return LearningSeries.firstIncompleteItem(videos, completeKeys);
	},
	firstIncompleteVideoInModuleAtLevel: function(module, level, completeKeys) {
		var videos = LearningSeries.itemsInModuleAtLevel(module, level, LearningSeries.VIDEO_TYPE);
		return LearningSeries.firstIncompleteItem(videos, completeKeys);
	},

	firstIncompleteItem: function(items, completeKeys) {
		var incompleteItems = _.filter(items, (item) => {
			return !(_.contains(completeKeys, item.key));
		});

		// returns the first incomplete item, or the first item if all are complete
		if (incompleteItems.length > 0) {
			return _.sortBy(incompleteItems, "order")[0];
		} else {
			return items[0];
		}
	},

	moduleName(module) {
		if (module == LearningSeries.SETUP_MODULE) {
			return "Account Setup";
		} else if (module == LearningSeries.STUDENT_MODULE) {
			return "Student Account";
		} else if (module == LearningSeries.TEACHER_MODULE) {
			return "Teacher Account";
		} else if (module == LearningSeries.QUICK_MODULE) {
			return "Quick Start";
		}
	}
}

LearningSeries.QUICK_MODULE = "quick-start";
LearningSeries.SETUP_MODULE = "account-setup";
LearningSeries.STUDENT_MODULE = "student-account";
LearningSeries.TEACHER_MODULE = "teacher-account";

LearningSeries.MODULES = [
	LearningSeries.QUICK_MODULE, LearningSeries.SETUP_MODULE, LearningSeries.STUDENT_MODULE,
	LearningSeries.TEACHER_MODULE
];

LearningSeries.BEG_LEVEL = "beginner";
LearningSeries.INT_LEVEL = "intermediate";
LearningSeries.ADV_LEVEL = "advanced";
LearningSeries.ACTION_TYPE = "action";
LearningSeries.VIDEO_TYPE = "video";

module.exports = LearningSeries;



// WEBPACK FOOTER //
// ./modules/lib/academic/LearningSeries.js